import { Button, Container, Typography } from "@mui/material";

import gifEpf from "../../images/logo/EPF 2024 GIF - LANDSCAPE.gif";
import logo2027 from "../../images/assets/2027logo.png";

function Landing() {
  return (
    <div className="home">
      <div className="home-tickets">
        <Container maxWidth="xl">
          <div className="border-lineup">
            <div className="info-container landing-container">
              <div className="info-container">
                <img src={logo2027} className="landing-logo" alt="2027logo" />

                <Typography className="title landing-title" variant="h6">
                  Sunday 5th Sep 2027
                </Typography>
                <Typography className="title landing-title" variant="h6">
                  Early birds - sold out
                </Typography>
                <Typography className="title landing-title" variant="h6">
                  2nd tier tickets on sale now
                </Typography>
                <Typography className="title landing-title" variant="h6">
                  <span>*plus booking fees</span>
                </Typography>
                <Button
                  href="https://edinburghpsychfest.seetickets.com/event/edinburgh-psych-fest-2027/various-venues/3708279"
                  color="primary"
                  size="large"
                  variant="contained"
                  sx={{
                    marginTop: "30px",
                    marginBottom: "0",
                    fontSize: "24px",
                    padding: "15px",
                    borderWidth: "3px",
                    borderRadius: "0px",
                  }}
                  target="_blank"
                  className="ticket-header-button"
                >
                  Buy Tickets
                </Button>
                <div className="info-container-divs logo-div">
                  <img src={gifEpf} className="gif-image" alt="lineup" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}
export default Landing;
